module.exports = __webpack_public_path__ + "img/313.081c34cf.jpg";